module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Strikethrough-885539b8ddbcbfdcd15660b370faf394.svg";